import { call, put, takeLatest } from 'redux-saga/effects';

import { Document } from '@models/Document';
import { DocumentApi } from '@apis/DocumentApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';
import { takeLatestByKey } from '@utils/saga';

import {
  documentsFetch,
  DocumentsFetchPayload,
  documentCreate,
  DocumentCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';


function* handleDocumentsFetch({ payload }: SagaPayload<DocumentsFetchPayload>) {
  const state: StateUpdatePayload = { [payload.documentType]: { documents: null, pagination: undefined } };
  try {
    const [documents, pagination] = (yield call(DocumentApi.getAll, payload)) as [Document[], Pagination];
    state[payload.documentType]!.documents = documents;
    state[payload.documentType]!.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleDocumentCreate({ payload }: SagaPayload<DocumentCreatePayload>) {
  try {
    yield call(DocumentApi.create, payload);
    const documentsFetchPayload: DocumentsFetchPayload = {
      documentableType: payload.documentableType,
      documentableId: payload.documentableId,
      documentType: payload.documentType,
      page: 1,
      perPage: 10,
    };
    yield put(documentsFetch(documentsFetchPayload));
  } catch { }
}

export default function* () {
  yield takeLatest(documentCreate, handleDocumentCreate);
  yield takeLatestByKey(documentsFetch, ({ payload }) => payload.documentType, handleDocumentsFetch);
}
